import { Observable } from "rxjs"
import PoolHistoryDetailsParameters from "./RandomsModel/PoolHistoryDetailsParameters"
import { ObservableFromFetch } from "../ObservableFromFetch"

export default function PoolHistoryDetailsGet(params: PoolHistoryDetailsParameters) {
  const requestBody = JSON.stringify(params)
  return ObservableFromFetch<string>("WorkforceReport/ExportPoolHistoryDetails", requestBody)
}
